import { InforModal } from "../model/datatype";
import Modal from "react-bootstrap/Modal";
import { Container, Row, Col, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import UniformImage from "../components/font-end/UniformSurvey/UniformImage";

export const InformationModal = (props: any) => {
  const { t } = useTranslation();
  //console.log("benefits=", props.benefit);
  return (
    <Modal
      show={props.showModal}
      onHide={props.handleContinue}
      className="custom-modal-unifrom  uniformModel"
    >
      <Modal.Header closeButton>
        <Modal.Title className="text-center w-100">
          {t("uniform_survey.your_uniform.title")}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="uniform-survey-info mb-1 mt-1">
          <Container>
            {props.benefit?.shirtQty > 0 ? (
              <Row className="mb-2 align-items-center">
                <Col xs={2} md={2} lg={2} className="m-0 p-1 text-center">
                <UniformImage imagesName={props.benefit?.shirtType} size="sm" customSize=""  />
                  {/* <img
                    src={`../images/uniformtype/${props.benefit?.shirtType.replace(
                      " ",
                      "-"
                    )}.jpg`}
                    alt="UniformSurvey"
                    width={45}
                    className="rounded border"
                  /> */}
                </Col>
                <Col xs={7} md={8} lg={8}>
                  <div className="list-title">
                    {localStorage.getItem("Language") === "en"
                      ? props.benefit?.shirtDescriptionEn
                      : props.benefit?.shirtDescriptionTh}
                  </div>
                  {/* <div className="list-size">Size: L (Male)</div> */}
                </Col>
                <Col xs={3} md={2} lg={2}>
                  <div className="number">{props.benefit?.shirtQty}</div>
                </Col>
              </Row>
            ) : (
              <></>
            )}
            {props.benefit?.pantsQty > 0 ? (
              <Row className="mb-2 align-items-center">
                <Col xs={2} md={2} lg={2} className="m-0 p-1 text-center">
                  <img
                    src="../images/uniform/pants.png"
                    alt="UniformSurvey"
                    width={45}
                    className="rounded border"
                  />
                </Col>
                <Col xs={7} md={8} lg={8}>
                  <div className="list-title">
                    {localStorage.getItem("Language") === "en"
                      ? props.benefit?.pantsDescriptionEn
                      : props.benefit?.pantsDescriptionTh}
                  </div>
                  {/* <div className="list-size">Size: M (Male)</div> */}
                </Col>
                <Col xs={3} md={2} lg={2}>
                  <div className="number">{props.benefit?.pantsQty}</div>
                </Col>
              </Row>
            ) : (
              <></>
            )}
            {props.benefit?.dressQty > 0 ? (
              <Row className="mb-2 align-items-center">
                <Col xs={2} md={2} lg={2} className="m-0 p-1 text-center">
                  <img
                    src="../images/uniform/dress.png"
                    alt="UniformSurvey"
                    width={45}
                    className="rounded border"
                  />
                </Col>
                <Col xs={7} md={8} lg={8}>
                  <div className="list-title">
                    {localStorage.getItem("Language") === "en"
                      ? props.benefit?.dressDescriptionEn
                      : props.benefit?.dressDescriptionTh}
                  </div>
                  <div className="list-size"></div>
                </Col>
                <Col xs={3} md={2} lg={2}>
                  <div className="number">{props.benefit?.dressQty}</div>
                </Col>
              </Row>
            ) : (
              <></>
            )}
            {props.benefit?.slipperQty > 0 ? (
              <Row className="mb-2 align-items-center">
                <Col xs={2} md={2} lg={2} className="m-0 p-1 text-center">
                  <img
                    src="../images/uniform/slippers.png"
                    alt="UniformSurvey"
                    width={45}
                    className="rounded border"
                  />
                </Col>
                <Col xs={7} md={8} lg={8}>
                  <div className="list-title">
                    {localStorage.getItem("Language") === "en"
                      ? props.benefit?.slipperDescriptionEn
                      : props.benefit?.slipperDescriptionTh}
                  </div>
                  {/* <div className="list-size">Size: 11</div> */}
                </Col>
                <Col xs={3} md={2} lg={2}>
                  <div className="number">{props.benefit?.slipperQty}</div>
                </Col>
              </Row>
            ) : (
              <></>
            )}
            {props.benefit?.braQty > 0 ? (
              <Row className="mb-2 align-items-center">
                <Col xs={2} md={2} lg={2} className="m-0 p-1 text-center">
                  <img
                    src="../images/uniform/bras.png"
                    alt="UniformSurvey"
                    width={45}
                    className="rounded border"
                  />
                </Col>
                <Col xs={7} md={8} lg={8}>
                  <div className="list-title">
                    {localStorage.getItem("Language") === "en"
                      ? props.benefit?.braDescriptionEn
                      : props.benefit?.braDescriptionTh}
                  </div>
                  {/* <div className="list-size">Size: 80 cm</div> */}
                </Col>
                <Col xs={3} md={2} lg={2}>
                  <div className="number">{props.benefit?.braQty}</div>
                </Col>
              </Row>
            ) : (
              <></>
            )}
            {props.benefit?.tumblerQty > 0 ? (
              <Row className="mb-2 align-items-center">
                <Col xs={2} md={2} lg={2} className="m-0 p-1 text-center">
                  <img
                    src="../images/uniform/tumbler.png?a1"
                    alt="UniformSurvey"
                    width={45}
                    className="rounded border"
                  />
                </Col>
                <Col xs={7} md={8} lg={8}>
                  <div className="list-title">
                    {localStorage.getItem("Language") === "en"
                      ? props.benefit?.tumblerDescriptionEn
                      : props.benefit?.tumblerDescriptionTh}
                  </div>
                  <div className="list-size"></div>
                </Col>
                <Col xs={3} md={2} lg={2}>
                  <div className="number">{props.benefit?.tumblerQty}</div>
                </Col>
              </Row>
            ) : (
              <></>
            )}
          </Container>
        </div>
      </Modal.Body>
    </Modal>
  );
};
